<template>
  <div class="originality-collection">
    <BaseInfo />
    <AdPreview />
  </div>
</template>

<script>
import BaseInfo from "./base-info/base-info";
import AdPreview from "./ad-preview/ad-preview";
export default {
  name: "originality-collection",
  props: {},
  data() {
    return {};
  },
  components: { BaseInfo, AdPreview },
  methods: {},
  created() {},
};
</script>

<style scoped lang='scss'>
.originality-collection {
  width: 1170px;
  display: flex;
  justify-content: space-between;
  >div {
   width: 49%;
  }
}
</style>